export const DEFAULT_PRODUCT_FILTERS = ['TK30', 'HK30', 'PM30'];
